import { shallowEqual } from "react-redux";
import { useBnbSelector } from "../../redux/store";
import { isGuardedService } from "./useServices";
import { type ServiceType, ServiceTypeEnum } from "../../../../../common-deprecated/types/SettingsType";
import { enabledServicesSelector } from "../../utils/selectorUtils";

const useService = (type: ServiceTypeEnum): ServiceType | null => {
    const { showFinance, showInsurance, showTradeIn } = useBnbSelector(enabledServicesSelector, shallowEqual);
    const configuredServices = useBnbSelector((state) => state.bnbSettings.services);

    if (!type) return null;

    const foundService = configuredServices.find((service) => service.type === type);
    if (!foundService) return null;

    if (
        !isGuardedService(type) ||
        (foundService.type === ServiceTypeEnum.Tradein && showTradeIn) ||
        (foundService.type === ServiceTypeEnum.Finance && showFinance) ||
        (foundService.type === ServiceTypeEnum.Insurance && showInsurance)
    ) {
        return foundService;
    }
    return null;
};

export default useService;
